import {PageData} from "/src/domain/shared/Page";
import {UpcomingRaceData} from "/src/domain/challenges/UpcomingRace";
import {LocalizedPrice} from "/src/domain/shared/LocalizedPrice";
import {ChallengeData} from "/src/domain/challenges/ChallengeTeamData";

export interface ChallengeRegistrationData extends PageData {
    upcomingRaces?: UpcomingRaceData[];
    name: string;
    locationDescription: string;
    locations: string[];
    startNumberUrl?: string;
    withStartNumber?: number;
    startPackOptions: StartPackOption[];
    isActive: boolean;
    distances?: Distance[];
    teamRegistration?: TeamRegistration;
    startreg: number;
    challengeKey: string;
    isPaid: boolean;
    payment?: PaymentInfo;
    challenge: ChallengeData;
    currentDateMsk: string;
}

export enum RegistrationStatus {
    NEW = 'new',
    PAID = 'paid'
}

export enum Currency {
    RUB = "rub",
    EUR = "eur"
}

export interface PaymentInfo {
    status?: RegistrationStatus;
    paymentUrl?: PaymentUrls;
    error?: any;
    options?: PaymentOptions;
    currency?: Currency;
}

export type PaymentOptions = {
    [key in Currency]: PaymentOption[];
};

export type PaymentUrls = {
    [key in Currency]: string;
};


export interface PaymentOption {
    label: string;
    price: number;
}


export interface StartPackOption {
    labelTextKey: string;
    helperTextKey: string;
    fieldName: string;
    enabledByDefault: boolean;
}

export interface ChallengePaidRegistrationData extends PageData {
    upcomingRaces: UpcomingRaceData[];
    raceOptions: RaceOption[];
    startPackOptions: StartPackPaidOption[];
    isActive: boolean;
    name: string;
    currency: string;
    id: number;
}

export interface RaceOption {
    label: string;
    price: LocalizedPrice;
    value: string;
    enabledByDefault: boolean;
    distanceGroups: DistanceGroupOption[];
}

export interface DistanceGroupOption {
    groupLabel: string;
    distances: Distance[];
}

export interface Distance {
    label: string;
    value: string;
}

export interface StartPackPaidOption {
    label: string;
    price: LocalizedPrice;
    enabledByDefault: boolean;
    value: string;
    sizes: StartPackSize[];
}

export enum PackSize {
    S = "size_s",
    M = "size_m",
    L = "size_l",
    XL = "size_xl",
}

export interface StartPackSize {
    value: PackSize;
    label: string;
}

export interface ChosenStartOption {
    value: string;
    size: PackSize;
}

export interface TeamRegistration {
    minTeamParticipants: number;
    maxTeamParticipants: number;
    teams: Team[];
    isTeamCreator?: boolean;
    teamKey?: string;
}

export interface Team {
    id: number;
    teamCode: string;
    region?: string;
    name: string;
    participants: TeamParticipant[];
    isPrivate: boolean;
}

export interface TeamParticipant {
    firstName?: string;
    lastName?: string;
    userId: string;
}
